/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Recent_UsageInputs */

const en_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Usage`)
};

const de_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Nutzung`)
};

const fr_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation récente`)
};

const es_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso reciente`)
};

const it_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzo recente`)
};

const nl_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente Gebruik`)
};

const pl_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie użycie`)
};

const fi_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeaikainen käyttö`)
};

const da_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste brug`)
};

const sv_settings_recent_usage = /** @type {(inputs: Settings_Recent_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste användning`)
};

/**
* | output |
* | --- |
* | "Recent Usage" |
*
* @param {Settings_Recent_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_recent_usage = /** @type {((inputs?: Settings_Recent_UsageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Recent_UsageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_recent_usage(inputs)
	if (locale === "fr") return fr_settings_recent_usage(inputs)
	if (locale === "es") return es_settings_recent_usage(inputs)
	if (locale === "it") return it_settings_recent_usage(inputs)
	if (locale === "nl") return nl_settings_recent_usage(inputs)
	if (locale === "pl") return pl_settings_recent_usage(inputs)
	if (locale === "fi") return fi_settings_recent_usage(inputs)
	if (locale === "da") return da_settings_recent_usage(inputs)
	if (locale === "sv") return sv_settings_recent_usage(inputs)
	return en_settings_recent_usage(inputs)
});